import React, {ReactNode, useEffect, useState} from "react";
import EnterpriseObject from "../eoec/eo/EnterpriseObject";
import enterpriseObjectClassFactory from "../eoec/EnterpriseObjectClassFactory";
import {Box, Button, Checkbox, FormControlLabel, FormGroup, IconButton, Popover, Tooltip, Typography} from "@mui/material";
import {Apps, ExpandCircleDown} from "@mui/icons-material";
import css_self from "./css/Pages.module.scss";
import css_button from "../components/Common/css/CCButton.module.scss";
import ProjectPlanTableApplet from "../eoec/applet/impl/ProjectPlan/ProjectPlanTableApplet";
import EventBus from "../util/EventBus";
import {hasPrivilege, useSessionContext} from "../util/SessionContext";
import css_buttons from "../components/Common/css/CCButton.module.scss";
import EnterpriseComponent from "../eoec/ec/EnterpriseComponent";
import LineChartExampleApplet from "../eoec/applet/impl/Chart/LineChartExampleApplet";
import ChartContainerExampleApplet from "../eoec/applet/impl/Chart/ChartContainerExampleApplet";
import BarChartExampleApplet from "../eoec/applet/impl/Chart/BarChartExampleApplet";
import ScatterChartExampleApplet from "../eoec/applet/impl/Chart/ScatterChartExampleApplet";
import HeatmapExampleApplet from "../eoec/applet/impl/Chart/HeatmapExampleApplet";
import PieChartExampleApplet from "../eoec/applet/impl/Chart/PieChartExampleApplet";
import FunnelChartExampleApplet from "../eoec/applet/impl/Chart/FunnelChartExampleApplet";
import RadarChartExampleApplet from "../eoec/applet/impl/Chart/RadarChartExampleApplet";
import GaugeExampleApplet from "../eoec/applet/impl/Chart/GaugeExampleApplet";
import SparklineExampleApplet from "../eoec/applet/impl/Chart/SparklineExampleApplet";


type MenuSelection = {id: string, target: EventTarget & HTMLButtonElement, option: string | null}

export default function ProjectPlan() {
    const sessionContext = useSessionContext();

    function onChangeVisibility() {
        projectPlanEnterpriseObject?.getEnterpriseComponent("ProjectPlan")?.invalidate()
    }

    const [projectPlanEnterpriseObject] = useState(enterpriseObjectClassFactory("ProjectPlan") as EnterpriseObject);

    const [perspectiveMenu, setPerspectiveMenu] = React.useState(1);
    const [viewOption, setViewOption] = React.useState<string | null>("Position");
    const [menu, setMenu] = React.useState<MenuSelection | null>(null);

    function enterpriseComponentDeleteCompletedListener(ec: EnterpriseComponent) {
         projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!.invalidate();
    }

    useEffect(() => {
        EventBus.visibility.addListener("change-visibility", onChangeVisibility);

        projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!.addDeleteCompletedListener(enterpriseComponentDeleteCompletedListener);

        return () => {
            projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!.removeDeleteCompletedListener(enterpriseComponentDeleteCompletedListener)

            EventBus.visibility.removeListener("change-visibility", onChangeVisibility);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let projectPlan;
    let commonContent;

    if (perspectiveMenu === 1) {
        commonContent = (
            <div style={{display: "flex", flexDirection: "column", backgroundColor: "#FFFFFF", height: "100vh", paddingRight: "60px"}}>
                <div style={{paddingLeft: "30px", paddingTop: "30px", width: "100%"}}>
                    <ProjectPlanTableApplet enterpriseComponent={projectPlanEnterpriseObject?.getEnterpriseComponent("ProjectPlan")} PageSize={{
                        "default": 40,
                    }}/>
                </div>
            </div>
        )
    }

    let visibility_modes = []

    if (hasPrivilege("Project Plan Multi Account")) visibility_modes.push("Multiple Company")
    if (hasPrivilege("Project Plan Organization")) visibility_modes.push("Organization")
    if (hasPrivilege("Project Plan Management")) visibility_modes.push("Management")
    visibility_modes.push("Position")
    if (hasPrivilege("Project Plan User Group")) visibility_modes.push("User Group")
    if (hasPrivilege("Project Plan Work Group")) visibility_modes.push("Work Group")

    function renderVisibilityMenu(visibilityBeingRendered: string) {
        let out: ReactNode;

        if ((visibilityBeingRendered === "Multiple Company") && hasPrivilege("Project Plan Multi Account") && (sessionContext.getActiveVisibility()!.Mode === "Multiple Company" ||
            sessionContext.getActiveVisibility()!.Mode === "Position" || sessionContext.getActiveVisibility()!.Mode === "Organization" || sessionContext.getActiveVisibility()!.Mode === "Management")) {
            out = (
                <div style={sessionContext.getActiveVisibility()!.Mode === "Multiple Company" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}} >
                    <div style={{display: "flex", flexDirection: "row", alignContent: "flex-start"}}>
                        <div>
                            <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                                sessionContext.setActiveVisibility(visibilityBeingRendered, sessionContext.getActiveVisibility()!.Value);
                                setViewOption(visibilityBeingRendered)
                                EventBus.visibility.emit("change-visibility", sessionContext.getActiveVisibility());
                            }}>{visibilityBeingRendered}</Button>
                        </div>
                        <div style={{marginLeft: "7px", marginTop: "6px"}}>
                            <IconButton className={css_button.blueIconButton} onClick={(e) => setMenu({id: "tenants", target: e.currentTarget, option: null})}>
                                <ExpandCircleDown/>
                            </IconButton>
                            {menu?.id === "tenants" ? (
                                <Popover
                                    anchorEl={menu.target}
                                    anchorOrigin={{vertical: "bottom", horizontal: "left"}}
                                    transformOrigin={{vertical: -12, horizontal: "left"}}
                                    open={true}
                                    onClose={() => setMenu(null)}
                                    slotProps={{
                                        paper: {
                                            elevation: 2,
                                        },

                                        transition: {
                                            onExited: () => setMenu(null),
                                        }
                                    }}>
                                    <Box sx={{p: 2, bgcolor: "background.paper", width: "auto", height: "auto"}}>
                                        <div style={{display: "flex", flexDirection: "column", padding: "10px"}}>
                                            <div style={{}}>
                                                <Typography style={{fontSize: "18px", fontWeight: "400", color: "#000000", textAlign: "left", borderBottom: "1px solid #D8DDE4"}}>Available Companies</Typography>
                                            </div>
                                            <div style={{marginTop: "10px"}}>
                                                <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "left"}}>Please select:</Typography>
                                            </div>
                                            <div>
                                                <FormGroup>
                                                    {sessionContext.getTenants().map(tenant => (
                                                        <FormControlLabel style={{marginBottom: "5px"}} control={<Checkbox defaultChecked />} label={tenant.Name} />
                                                    ))}
                                                </FormGroup>
                                            </div>
                                            <div style={{marginTop: "20px", marginLeft: "auto", marginRight: "auto"}}>
                                                <Button
                                                    className={css_buttons.blueStandardButton} style={{width: "200px"}}
                                                    onClick={() => null}>
                                                    Select
                                                </Button>
                                            </div>
                                        </div>
                                    </Box>
                                </Popover>
                            ) : null}
                        </div>
                    </div>
                </div>
            )
        } else if ((visibilityBeingRendered === "Organization") && hasPrivilege("Project Plan Organization") && (sessionContext.getActiveVisibility()!.Mode === "Multiple Company" || sessionContext.getActiveVisibility()!.Mode === "Position" || sessionContext.getActiveVisibility()!.Mode === "Organization" || sessionContext.getActiveVisibility()!.Mode === "Management")) {
            out = (
                <div style={sessionContext.getActiveVisibility()!.Mode === "Organization" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}}  >
                    <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                        sessionContext.setActiveVisibility(visibilityBeingRendered, sessionContext.getActiveVisibility()!.Value);
                        setViewOption(visibilityBeingRendered)
                        EventBus.visibility.emit("change-visibility", sessionContext.getActiveVisibility());
                    }}>{visibilityBeingRendered}</Button>
                </div>
            )
        } else if ((visibilityBeingRendered === "Management") && hasPrivilege("Project Plan Management") && (sessionContext.getActiveVisibility()!.Mode === "Multiple Company" || sessionContext.getActiveVisibility()!.Mode === "Position" || sessionContext.getActiveVisibility()!.Mode === "Organization" || sessionContext.getActiveVisibility()!.Mode === "Management")) {
            out = (
                <div style={sessionContext.getActiveVisibility()!.Mode === "Management" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}}  >
                    <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                        sessionContext.setActiveVisibility(visibilityBeingRendered, sessionContext.getActiveVisibility()!.Value);
                        setViewOption(visibilityBeingRendered)
                        EventBus.visibility.emit("change-visibility", sessionContext.getActiveVisibility());
                    }}>{visibilityBeingRendered}</Button>
                </div>
            )
        } else if ((visibilityBeingRendered === "Position") && (sessionContext.getActiveVisibility()!.Mode === "Multiple Company" || sessionContext.getActiveVisibility()!.Mode === "Position" || sessionContext.getActiveVisibility()!.Mode === "Organization" || sessionContext.getActiveVisibility()!.Mode === "Management")) {
            out = (
                <div style={sessionContext.getActiveVisibility()!.Mode === "Position" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}}>
                    <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                        sessionContext.setActiveVisibility(visibilityBeingRendered, sessionContext.getActiveVisibility()!.Value);
                        setViewOption(visibilityBeingRendered)
                        EventBus.visibility.emit("change-visibility", sessionContext.getActiveVisibility());
                    }}>{visibilityBeingRendered}</Button>
                </div>
            )
        } else if ((visibilityBeingRendered === "User Group") && sessionContext.getActiveVisibility()!.Mode === "User Group") {
            out = (
                <div style={sessionContext.getActiveVisibility()!.Mode === "User Group" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}}>
                    <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                        sessionContext.setActiveVisibility(visibilityBeingRendered, sessionContext.getActiveVisibility()!.Value);
                        setViewOption(visibilityBeingRendered)
                        EventBus.visibility.emit("change-visibility", sessionContext.getActiveVisibility());
                    }}>{visibilityBeingRendered}</Button>
                </div>
            )
        } else if ((visibilityBeingRendered === "Work Group") && sessionContext.getActiveVisibility()!.Mode === "Work Group") {
            out = (
                <div style={sessionContext.getActiveVisibility()!.Mode === "Work Group" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}}>
                    <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                        sessionContext.setActiveVisibility(visibilityBeingRendered, sessionContext.getActiveVisibility()!.Value);
                        setViewOption(visibilityBeingRendered)
                        EventBus.visibility.emit("change-visibility", sessionContext.getActiveVisibility());
                    }}>{visibilityBeingRendered}</Button>
                </div>
            )
        }

        return out;
    }

    projectPlan = (
        <>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", borderBottom: "1px solid #EFEFEF", paddingBottom: "15px", height: "40px"}}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                    {visibility_modes.map((visibility_mode, i) => (
                        <div key={visibility_mode} style={{paddingTop: "10px", marginLeft: i === 0 || i === 1 ? "30px" : "35px"}}>
                            {renderVisibilityMenu(visibility_mode)}
                        </div>
                    ))}
                </div>
            </div>
            {viewOption === "Multiple Company" ? (
                commonContent
            ): null}
            {viewOption === "Organization" ? (
                commonContent
            ): null}
            {viewOption === "Management" ? (
                commonContent
            ): null}
            {viewOption === "Position" ? (
                commonContent
            ): null}
            {viewOption === "User Group" ? (
                commonContent
            ): null}
            {viewOption === "Work Group" ? (
                commonContent
            ): null}
        </>
    )

    let visibilityMode = sessionContext.getActiveVisibility()!.Mode;
    let visibilityValue = sessionContext.getActiveVisibility()!.Value;
    let visibilityTitle = null;

    if (visibilityMode === "Organization") {
        for (let i = 0; i < sessionContext.getAccount()!["Positions"].length; i++) {
            if (sessionContext.getAccount()!["Positions"][i].USID === visibilityValue) {
                visibilityTitle = sessionContext.getAccount()!["Positions"][i].Name;
                visibilityMode = "Position";
                break;
            }
        }
    } else if (visibilityMode === "Management") {
        for (let i = 0; i < sessionContext.getAccount()!["Positions"].length; i++) {
            if (sessionContext.getAccount()!["Positions"][i].USID === visibilityValue) {
                visibilityTitle = sessionContext.getAccount()!["Positions"][i].Name;
                visibilityMode = "Position";
                break;
            }
        }
    } else if (visibilityMode === "Position") {
        for (let i = 0; i < sessionContext.getAccount()!["Positions"].length; i++) {
            if (sessionContext.getAccount()!["Positions"][i].USID === visibilityValue) {
                visibilityTitle = sessionContext.getAccount()!["Positions"][i].Name;
                visibilityMode = "Position";
                break;
            }
        }
    } else if (visibilityMode === "User Group") {
        for (let i = 0; i < sessionContext.getAccount()!["UserGroups"].length; i++) {
            if (sessionContext.getAccount()!["UserGroups"][i].USID === visibilityValue) {
                visibilityTitle = sessionContext.getAccount()!["UserGroups"][i].Name;
                visibilityMode = "User Group";
                break;
            }
        }
    } else if (visibilityMode === "Work Group") {
        for (let i = 0; i < sessionContext.getAccount()!["WorkGroups"].length; i++) {
            if (sessionContext.getAccount()!["WorkGroups"][i].USID === visibilityValue) {
                visibilityTitle = sessionContext.getAccount()!["WorkGroups"][i].Name;
                visibilityMode = "Work Group";
                break;
            }
        }
    }

    function changePerspective(menu: number) {
        setPerspectiveMenu(menu);
        setMenu(null)
    }

    return (
        // minHeight: 100% so the page FILLS the window and anything drawn down its edge -- a panel
        // separator, a column rule -- runs the whole way rather than stopping where the content
        // happens to end. NOT a fixed height: this page has no scroll region of its own, so a fixed
        // height would clip whatever ran past the fold with no way to reach it. minHeight fills when
        // the content is short and grows when it is long; the shell scrolls it either way.
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1, minHeight: "100%"}}>
            <LineChartExampleApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanChart")}/>
            <ChartContainerExampleApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanChart")}/>
            <BarChartExampleApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanChart")}/>
            <ScatterChartExampleApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanChart")}/>
            <HeatmapExampleApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanChart")}/>
            <PieChartExampleApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanChart")}/>
            <FunnelChartExampleApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanChart")}/>
            <RadarChartExampleApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanChart")}/>
            <GaugeExampleApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanChart")}/>
            <SparklineExampleApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanChart")}/>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                    <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>Project Plan</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginRight: "20px"}}>
                        {sessionContext.getActiveVisibility()!.Mode !== visibilityMode &&
                            <Typography style={{fontSize: 14, fontWeight: 400, color: "#FFFFFF"}}>{sessionContext.getActiveVisibility()!.Mode}</Typography>}
                        <Typography style={{fontSize: 14, fontWeight: 400, color: "#FFFFFF"}}>{visibilityMode}: {visibilityTitle}</Typography>
                    </div>
                    <div style={{marginRight: "15px", marginTop: "10px"}}>
                        <Tooltip title={"Perspective Selector"}>
                            <IconButton className={css_buttons.blueIconButton2} onClick={(e) => setMenu({id: "rolePerspectiveMenu", target: e.currentTarget, option: null})}>
                                <Apps/>
                            </IconButton>
                        </Tooltip>
                        {menu?.id === "rolePerspectiveMenu" ? (
                            <Popover
                                anchorEl={menu.target}
                                anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                transformOrigin={{vertical: -11, horizontal: "left"}}
                                open={true}
                                onClose={() => setMenu(null)}
                                slotProps={{
                                    paper: {
                                        elevation: 2,
                                    },

                                    transition: {
                                        onExited: () => setMenu(null),
                                    }
                                }}>
                                <Box sx={{p: 2, bgcolor: "background.paper", width: "400px", height: "75px"}}>
                                    <div style={{display: "flex", flexDirection: "column"}}>
                                        <div style={{padding: "10px", cursor: "pointer"}} onClick={() => changePerspective(1)}>
                                            <Typography style={{fontSize: 20, fontWeight: 500, color: "#1498D8", marginTop: "3px"}}>Project Plan List</Typography>
                                            <Typography style={{fontSize: 14, fontWeight: 400, color: "#000000", marginTop: "3px"}}>A list of project plans available to your selected persona.</Typography>
                                        </div>
                                    </div>
                                </Box>
                            </Popover>
                        ) : null}
                    </div>
                </div>
            </div>
            {projectPlan}
        </div>
    );
}